import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content", "icon"]

  toggle(event) {
    const button = event.currentTarget
    const content = button.parentElement.querySelector('[data-accordion-target="content"]')
    const icon = button.querySelector('[data-accordion-target="icon"]')

    const isExpanded = button.getAttribute("aria-expanded") === "true"

    // Toggle content visibility
    content.style.maxHeight = isExpanded ? "0" : `${content.scrollHeight}px`
    content.style.opacity = isExpanded ? "0" : "1"

    // Toggle icon rotation
    icon.classList.toggle("rotate-180", !isExpanded)

    // Update button aria state
    button.setAttribute("aria-expanded", (!isExpanded).toString())
  }
}
